import { render, staticRenderFns } from "./EpcArrayWallonia.vue?vue&type=template&id=4f021405&scoped=true&"
import script from "./EpcArrayWallonia.vue?vue&type=script&lang=js&"
export * from "./EpcArrayWallonia.vue?vue&type=script&lang=js&"
import style0 from "./EpcArrayWallonia.vue?vue&type=style&index=0&id=4f021405&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f021405",
  null
  
)

export default component.exports